export let stateCodes: Record<string, string> = {
    'Andhra pradesh': '37',
    'Arunachal pradesh': '12',
    'Assam': '18',
    'Bihar': '10',
    'Chhattisgarh': '22',
    'Goa': '30',
    'Gujarat': '24',
    'Haryana': '06',
    'Himachal pradesh': '02',
    'Jharkhand': '20',
    'Karnataka': '29',
    'Kerala': '32',
    'Madhya pradesh': '23',
    'Maharashtra': '27',
    'Manipur': '14',
    'Meghalaya': '17',
    'Mizoram': '15',
    'Nagaland': '13',
    'Odisha': '21',
    'Punjab': '03',
    'Rajasthan': '08',
    'Sikkim': '11',
    'Tamil nadu': '33',
    'Telangana': '36',
    'Tripura': '16',
    'Uttar pradesh': '09',
    'Uttarakhand': '05',
    'West bengal': '19',
    'Andaman and nicobar islands': '35',
    'Chandigarh': '04',
    'Dadra and nagar haveli and daman and diu': '26',
    'Lakshadweep': '31',
    'Puducherry': '34',
    'Delhi': '07',
    'Ladakh': '38',
    'Jammu and kashmir': '01'
  };